// components/ui/Skeleton.tsx — Shimmer loading placeholder

import clsx from 'clsx';
import styles from './Skeleton.module.css';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  className?: string;
}

export function Skeleton({ width, height, borderRadius, className }: SkeletonProps) {
  return (
    <span
      className={clsx(styles.skeleton, 'shimmer', className)}
      style={{
        width: width ?? '100%',
        height: height ?? '1em',
        borderRadius: borderRadius ?? 'var(--radius-sm)',
        display: 'inline-block',
      }}
      aria-hidden="true"
    />
  );
}

// Convenience: node card skeleton (used in tree loading state)
export function NodeSkeleton() {
  return (
    <div className={styles.node}>
      <Skeleton width={48} height={48} borderRadius="50%" />
      <div className={styles.nodeInfo}>
        <Skeleton width="70%" height={14} />
        <Skeleton width="45%" height={11} />
      </div>
    </div>
  );
}

// Convenience: profile card skeleton
export function ProfileSkeleton() {
  return (
    <div className={styles.profile}>
      <Skeleton width={80} height={80} borderRadius="50%" />
      <Skeleton width="60%" height={20} />
      <Skeleton width="40%" height={14} />
      <Skeleton width="100%" height={12} />
      <Skeleton width="85%" height={12} />
    </div>
  );
}
